import React from 'react';
import PropTypes from 'prop-types';

class PrintButton extends React.PureComponent {
  static createPrintButton(handler) {
    const button = (
      <button
        id="print_button"
        key="print_button"
        rel="tooltip"
        onClick={handler}
        title="Print Document"
        className="btn js-reactivation-offer"
      />
    );
    return button;
  }

  constructor() {
    super();
    this.printButtonExportOnClick = this.printButtonExportOnClick.bind(this);
    this.printButtonOnClick = this.printButtonOnClick.bind(this);
  }

  printButtonExportOnClick() {
    if (this.props.disabled) {
      return;
    }
    window.ReactCompatibility.saveFreeWriteContent();
    if (this.props.showConvertDoc) {
      window.ExportDocument.exportDocx();
    } else {
      window.ExportDocument.processExport(false, 1);
    }
    window._track('Print | Print Button', `${this.props.documentType} | FreeWrite-Builder${this.props.memberTracking}`);
  }

  printButtonOnClick() {
    if (this.props.disabled) {
      return false;
    }
    window.ReactCompatibility.saveFreeWriteContent();
    setTimeout(() => {
      document.location.href = window.ExportDocument.newAccountPath + document.location.search;
    }, 1500);
    return false;
  }

  render() {
    return (
      <div className="pull-right">
        {this.props.showPrintButton && (
          PrintButton.createPrintButton(this.printButtonExportOnClick)
        )}
        {this.props.showPrintButtonCta && (
          PrintButton.createPrintButton(this.printButtonOnClick)
        )}
      </div>
    );
  }
}

PrintButton.defaultProps = {
  showPrintButton: false,
  showPrintButtonCta: false,
  showConvertDoc: false,
  disabled: false,
  memberTracking: '',
  documentType: '',
};

PrintButton.propTypes = {
  showPrintButton: PropTypes.bool,
  showPrintButtonCta: PropTypes.bool,
  showConvertDoc: PropTypes.bool,
  disabled: PropTypes.bool,
  memberTracking: PropTypes.string,
  documentType: PropTypes.string,
};


export default PrintButton;



// WEBPACK FOOTER //
// ./src-react/ExportToolbar/PrintButton.jsx